import React, { useState, useEffect } from "react";
import { Joyride, STATUS } from "react-joyride";

const TOUR_STEPS = [
  {
    target: '[data-tour="nav-dashboard"]',
    content: "Aquí volvés al dashboard principal en cualquier momento.",
  },
  {
    target: '[data-tour="nav-operaciones"]',
    content: "Desde Operaciones administrás equipos, servicios y almacén.",
  },
  {
    target: '[data-tour="nav-admin"]',
    content: "En Administración configurás usuarios y ajustes de la plataforma.",
  },
  {
    target: '[data-tour="user-menu"]',
    content: "Aquí accedés a tu perfil y cerrás sesión.",
  },
  {
    target: '[data-tour="dashboard-kpis"]',
    content: "Estos indicadores resumen el estado general de tus equipos.",
  },
  {
    target: '[data-tour="dashboard-charts"]',
    content: "Acá ves cronogramas y gráficas de tu operación.",
  },
];

const DashboardTour = ({ run, onFinish }) => {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (!run) return;

    const available = TOUR_STEPS.filter((step) =>
      document.querySelector(step.target),
    );

    if (available.length === 0) {
      onFinish();
      return;
    }

    setSteps(available);
    // eslint-disable-next-line
  }, [run]);

  if (!run || steps.length === 0) return null;

  const handleEvent = (data) => {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(data.status)) {
      onFinish();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      onEvent={handleEvent}
      options={{
        buttons: ["back", "close", "primary", "skip"],
        showProgress: true,
        primaryColor: "#2563eb",
        zIndex: 10000,
      }}
      locale={{
        back: "Atrás",
        close: "Cerrar",
        last: "Finalizar",
        next: "Siguiente",
        skip: "Saltar",
      }}
    />
  );
};

export default DashboardTour;
